import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import { LeadProvider } from './LeadModal';
import { ContentProvider } from '../lib/content';
import SiteInjectors from '../lib/injectors';
import Navbar, { StickyCTA } from './Navbar';
import Footer from './Footer';
import CustomSections from './CustomSections';
import PopupManager from './Popups';

export default function Layout() {
  const { pathname, hash } = useLocation();
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => lenisRef.current?.scrollTo(el, { offset: -90 }), 60);
        return;
      }
    }
    lenisRef.current?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return (
    <LeadProvider>
      <ContentProvider>
        <SiteInjectors />
        <div className="min-h-screen bg-paper font-sans text-navy">
          <Navbar />
          <main>
            <Outlet />
            <CustomSections />
          </main>
          <Footer />
          <PopupManager />
          <StickyCTA />
        </div>
      </ContentProvider>
    </LeadProvider>
  );
}
